export const ONBOARDED_STORAGE_KEY = 'mw__onboarded'
export const WHATSNEW_STORAGE_KEY = 'mw__whatsnew_version_im'
